import { gql } from '@apollo/client/core'

export const INCIDENT_REPORTING_ENABLED_QUERY = gql`
  query incidentReportingEnabled {
    incidentReportingEnabled
  }
`

export const INCIDENT_SUBJECTS_QUERY = gql`
  query incidentSubjects($query: String) {
    incidentSubjects(query: $query) {
      type
      id
      label
      rentalCode
      projectName
      startDate
      endDate
    }
  }
`

export const CREATE_CUSTOMER_INCIDENT_MUTATION = gql`
  mutation createCustomerIncident($input: CreateCustomerIncidentInput!) {
    createCustomerIncident(input: $input) {
      incident {
        id
        reference
      }
      errors {
        path
        message
      }
    }
  }
`
